export default "__VITE_ASSET__3JEuRIP___"